module.exports = __webpack_public_path__ + "static/MT_Process-08.d59d4a8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/process-icons/MT_Process-08.png
// module id = 1505
// module chunks = 214286880276331